module.exports = __webpack_public_path__ + "static/media/steto.370270be.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/steto.svg
// module id = 557
// module chunks = 0